import moment from "moment";
import React, { useState } from "react";
import Button1 from "../../form/Button1";
import TextInput from "../../form/TextInput";
import { buildComparePassengers, ComparePAX } from "./ComparePAX";
import { PriceBreakdown } from "./PriceBreakdown";
import { CompareFlightChange } from "./CompareFlightChange";
import { enqueueSnackbar } from "notistack";
import StaffApiErrorModal, {
  getStaffApiErrorCopy,
} from "../StaffApiErrorModal";
import setChangeFee from "../../../controllers/booking/postTicketing/change/setChangeFee";

export default function EditTicket({ data, reload }) {
  const [details, setDetails] = useState("");
  const [loadings, setLoadings] = useState({
    submit: false,
  });
  const [apiError, setApiError] = useState(null);
  const [feeData, setFeeData] = useState({
    penality: data?.fee || 0,
    ticketDifference: data?.ticketDifference || 0,
  });

  async function handleSubmit() {
    const reqBody = {
      changeOrderId: data?._id,
      changePrice: Number(feeData?.penality || 0),
      ticketDifference: Number(feeData?.ticketDifference || 0),
      remark: details,
    };
    setLoadings({ ...loadings, submit: true });
    const res = await setChangeFee(reqBody);
    setLoadings({ ...loadings, submit: false });

    if (res.return) {
      enqueueSnackbar("Quote Complete.", { variant: "success" });
      reload && reload();
    } else setApiError(getStaffApiErrorCopy(res));
  }

  function handlePriceChange(data) {
    setFeeData(data);
  }

  //   console.log({ data, type: "Edit ticket" });
  let title = "PAX Change";
  if (data?.newSegment?.length) title = "Date Change";
  return (
    <>
    <div className="flex flex-col gap-4">
      <div>
        <div className="flex gap-1">
          <p>Ticket Number: </p>
          <span>{data?.orderId}</span>
        </div>
        <div className="flex gap-1">
          <p>Re-issue Request Time: </p>
          <span>
            {data?.updatedAt
              ? moment(data?.updatedAt)?.format("YYYY-MM-DD, HH:mm")
              : ""}
          </span>
        </div>
      </div>
      <div className="flex justify-end">
        <div>
          <Button1 variant="text">Check fare rules</Button1>
        </div>
      </div>
      {title === "PAX Change" ? (
        <ComparePAX
          data={{ passengers: buildComparePassengers(data) }}
        />
      ) : (
        <CompareFlightChange
          data={{ flight: data, oldOrder: data, query: data }}
        />
      )}

      <PriceBreakdown data={data} callback={handlePriceChange} />

      <TextInput
        label="Remarks"
        multiline
        rows={4}
        value={details}
        onChange={(ev) => setDetails(ev.target.value)}
      />

      <div className="flex justify-end">
        <div>
          <Button1 onClick={handleSubmit}>Confirm</Button1>
        </div>
      </div>
    </div>
    <StaffApiErrorModal
      open={Boolean(apiError)}
      setOpen={(next) => {
        if (!next) setApiError(null);
      }}
      title={apiError?.title}
      text={apiError?.text}
    />
    </>
  );
}
